import * as React from "react"

const TabsContainer: React.FC = ({ children }) => {
  return <div className="flex items-center justify-center">{children}</div>
}

export default TabsContainer
